import api from '../token';

export const ListFamilia = async () => {
  try {
    const response = await api.post('/getFamilia');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

